import { Reducer } from 'redux';
import produce from 'immer';
import { BoxesState, BoxesTypes } from './types';
import { AuthTypes } from '../auth/types';

const INITIAL_STATE: BoxesState = {
  // eslint-disable-next-line
  // @ts-ignore
  boxes: {},
  loading: true,
  refreshing: false,
  error: false,
  pendingRequest: true,
};

function hasBoxes(boxes: any): boolean {
  return boxes && Object.keys(boxes).length > 0;
}

const boxes: Reducer<BoxesState> = (state = INITIAL_STATE, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case BoxesTypes.BOXES_REQUEST: {
        if (hasBoxes(draft.boxes)) {
          // Already have data — don't show skeleton, just mark as refreshing
          draft.refreshing = true;
        } else {
          // First load — show skeleton
          draft.loading = true;
        }
        break;
      }
      case BoxesTypes.BOXES_SUCCESS: {
        draft.boxes = action.payload.boxes || INITIAL_STATE.boxes;
        draft.loading = false;
        draft.refreshing = false;
        draft.pendingRequest = false;
        break;
      }
      case BoxesTypes.BOXES_FAILURE: {
        draft.boxes = draft.boxes || INITIAL_STATE.boxes;
        draft.loading = false;
        draft.refreshing = false;
        draft.error = true;
        break;
      }
      case BoxesTypes.BOXES_SETPENDING: {
        draft.pendingRequest = true;
        break;
      }
      case AuthTypes.LOGOUT: {
        draft.boxes = INITIAL_STATE.boxes;
        draft.loading = true;
        draft.refreshing = false;
        break;
      }
      default:
    }
  });
};

export default boxes;
